import { render, staticRenderFns } from "./ForestCovertureFrench.vue?vue&type=template&id=3d32f5cc&scoped=true"
import script from "./ForestCovertureFrench.vue?vue&type=script&lang=js"
export * from "./ForestCovertureFrench.vue?vue&type=script&lang=js"
import style0 from "./ForestCovertureFrench.vue?vue&type=style&index=0&id=3d32f5cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d32f5cc",
  null
  
)

export default component.exports